var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticClass: "control-panel_card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("span", [_vm._v("统计数据")]),
              _c(
                "el-button",
                {
                  staticStyle: { float: "right", padding: "3px 0" },
                  attrs: { type: "text" },
                  on: { click: _vm.handleRefresh },
                },
                [_vm._v("刷新")]
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: _vm.getIsMobile ? 24 : 3 } },
                [
                  _c("el-statistic", {
                    attrs: {
                      value: _vm.statisticalData.newm_c,
                      title: "今日新增客户",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.getIsMobile ? 24 : 3 } },
                [
                  _c("el-statistic", {
                    attrs: {
                      value: _vm.statisticalData.quote_c,
                      title: "今日报价",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.getIsMobile ? 24 : 3 } },
                [
                  _c("el-statistic", {
                    attrs: {
                      value: _vm.statisticalData.price_m,
                      title: "当月成交额",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.getIsMobile ? 24 : 3 } },
                [
                  _c("el-statistic", {
                    attrs: {
                      value: _vm.statisticalData.fukuan_m,
                      title: "当月到账额",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.getIsMobile ? 24 : 3 } },
                [
                  _c("el-statistic", {
                    attrs: {
                      value: _vm.statisticalData.arrears_m,
                      title: "客户总欠款",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.getIsMobile ? 24 : 3 } },
                [
                  _c("el-statistic", {
                    attrs: {
                      value: _vm.statisticalData.price_d,
                      title: "今日成交额",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.getIsMobile ? 24 : 3 } },
                [
                  _c("el-statistic", {
                    attrs: {
                      value: _vm.statisticalData.fukuan_d,
                      title: "今日到账额",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("el-card", { staticClass: "control-panel_card" }, [
        _c("div", {
          ref: "chartRef",
          staticStyle: { width: "100%", height: "400px" },
        }),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }